var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 34 -4)",
    fill: "#6CC04A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 8,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.617 26.969v6.657H26.96v-2h3.253l-4.455-4.455 1.414-1.414 4.444 4.443v-3.231zM11.03 4.384H4.374v6.656h2V7.787l4.454 4.455 1.414-1.414L7.8 6.384h3.23z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 4
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iIzZDQzA0QSI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIwIC0xNjgpIHRyYW5zbGF0ZSgwIDU2KSBtYXRyaXgoLTEgMCAwIDEgNTQgMTA4KSI+CiAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBjeD0iMTkiIGN5PSIxOSIgcj0iOCIgb3BhY2l0eT0iLjQiLz4KICAgICAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTUuNDE0IDEuM0wxMC4xMjEgNi4wMDcgNS40MTQgMTAuNzE0IDQgOS4zIDYuMyA2Ljk5OSAwIDcgMCA1IDYuMjg0IDQuOTk5IDQgMi43MTR6IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAtMTEuNDcgNDguMTc4KSIvPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTUuNDE0IDAuM0wxMC4xMjEgNS4wMDcgNS40MTQgOS43MTQgNCA4LjMgNi4zIDUuOTk5IDAgNiAwIDQgNi4yODQgMy45OTkgNCAxLjcxNHoiIHRyYW5zZm9ybT0ic2NhbGUoLTEgMSkgcm90YXRlKC00NSAyLjEyMSAyMi4xOTIpIi8+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjE5IiBjeT0iMTkiIHI9IjQiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIconZoom as ReactComponent };